import * as t from "io-ts"

/** A ts-io value represented the result returned when getting a large attachment url  */
export const LargeAttachmentRes = t.type({
    download_url: t.string,
    fileName: t.string,
})

/** A type derived from the LargeAttachmentRes ts-io value representing a large attachment url */
export type ILargeAttachmentRes = t.TypeOf<typeof LargeAttachmentRes>
